import ReceptionLayout from './ReceptionLayout';

export default ReceptionLayout;
